module.exports = __webpack_public_path__ + "img/login_banner.78c20002.png";